export const CompassLogoNeutral = () => (
  <svg
    width="232"
    height="48"
    viewBox="0 0 232 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.53 37.547C68.617 38.807 65.583 39.367 62.41 39.367C52.33 39.367 46.637 33.2999 46.637 23.6399C46.637 14.3069 52.33 7.77295 62.317 7.77295C65.304 7.77295 68.29 8.33295 70.484 9.91995V13.9799C68.29 12.5799 65.864 11.8329 62.317 11.8329C55.13 11.8329 50.837 16.5929 50.837 23.6389C50.837 30.6849 55.27 35.353 62.55 35.353C65.77 35.353 68.29 34.606 70.53 33.486V37.546V37.547Z"
      fill="#44546F"
    />
    <path
      d="M74.4041 27.1871C74.4041 20.1871 78.5111 15.1001 85.5111 15.1001C92.4641 15.1001 96.5241 20.1871 96.5241 27.1871C96.5241 34.1871 92.4641 39.3671 85.5111 39.3671C78.5111 39.3671 74.4041 34.1871 74.4041 27.1871ZM78.3241 27.1871C78.3241 31.6201 80.5171 35.6331 85.5111 35.6331C90.4581 35.6331 92.604 31.6201 92.604 27.1871C92.604 22.7541 90.4571 18.8331 85.5111 18.8331C80.5171 18.8331 78.3241 22.7531 78.3241 27.1871Z"
      fill="#44546F"
    />
    <path
      d="M121.024 38.9001H117.011V24.8071C117.011 20.6071 115.331 18.7401 111.504 18.7401C107.771 18.7401 105.204 21.2131 105.204 25.9271V38.9001H101.191V15.5661H105.204V19.3931C106.697 16.6401 109.451 15.1001 112.578 15.1001C116.545 15.1001 119.251 17.1071 120.418 20.7941C121.725 17.2001 124.851 15.1001 128.725 15.1001C133.952 15.1001 136.845 18.6471 136.845 25.2271V38.9001H132.832V25.9271C132.832 21.1201 131.152 18.7401 127.325 18.7401C123.592 18.7401 121.025 21.2131 121.025 25.9271V38.9001H121.024Z"
      fill="#44546F"
    />
    <path
      d="M146.925 34.7931V48.0001H142.912V15.5661H146.925V19.7661C148.419 16.6861 151.218 15.0991 154.812 15.0991C161.018 15.0991 164.145 20.3731 164.145 27.2331C164.145 33.8131 160.878 39.3661 154.345 39.3661C150.938 39.3661 148.325 37.8261 146.925 34.7921V34.7931ZM153.738 18.8331C150.145 18.8331 146.925 21.1201 146.925 26.2991V28.1661C146.925 33.3461 149.865 35.6321 153.272 35.6321C157.799 35.6321 160.132 32.6451 160.132 27.2321C160.132 21.6321 157.892 18.8321 153.739 18.8321L153.738 18.8331Z"
      fill="#44546F"
    />
    <path
      d="M185.099 34.7001C183.606 37.7801 180.806 39.3671 177.213 39.3671C171.006 39.3671 167.88 34.0941 167.88 27.2341C167.88 20.6541 171.147 15.1001 177.68 15.1001C181.087 15.1001 183.7 16.6401 185.1 19.6741V15.5671H189.114V38.9011H185.1V34.7011L185.099 34.7001ZM178.286 35.6331C181.88 35.6331 185.099 33.3461 185.099 28.1671V26.3001C185.099 21.1201 182.159 18.8341 178.753 18.8341C174.226 18.8341 171.892 21.8211 171.892 27.2341C171.892 32.8341 174.132 35.6341 178.285 35.6341L178.286 35.6331Z"
      fill="#44546F"
    />
    <path
      d="M202.506 39.3671C199.006 39.3671 196.159 38.5741 194.386 37.6401V33.3931C196.393 34.5601 199.753 35.6801 202.692 35.6801C205.772 35.6801 207.359 34.4201 207.359 32.6001C207.359 30.8271 206.006 29.8001 201.573 28.7271C196.393 27.4671 194.2 25.4601 194.2 21.6341C194.2 17.5741 197.327 15.1001 202.646 15.1001C205.679 15.1001 208.433 15.8471 210.16 16.7801V20.9341C207.36 19.5341 205.073 18.7871 202.6 18.7871C199.66 18.7871 198.074 19.8131 198.074 21.6341C198.074 23.2671 199.194 24.2941 203.487 25.3201C208.667 26.5801 211.281 28.4941 211.281 32.5531C211.281 36.4261 208.761 39.3661 202.507 39.3661L202.506 39.3671Z"
      fill="#44546F"
    />
    <path
      d="M223.227 39.3671C219.727 39.3671 216.88 38.5741 215.106 37.6401V33.3931C217.113 34.5601 220.473 35.6801 223.413 35.6801C226.493 35.6801 228.08 34.4201 228.08 32.6001C228.08 30.8271 226.727 29.8001 222.293 28.7271C217.113 27.4671 214.92 25.4601 214.92 21.6341C214.92 17.5741 218.047 15.1001 223.367 15.1001C226.4 15.1001 229.153 15.8471 230.88 16.7801V20.9341C228.08 19.5341 225.794 18.7871 223.32 18.7871C220.38 18.7871 218.793 19.8131 218.793 21.6341C218.793 23.2671 219.913 24.2941 224.207 25.3201C229.387 26.5801 232 28.4941 232 32.5531C232 36.4261 229.48 39.3661 223.227 39.3661V39.3671Z"
      fill="#44546F"
    />
    <path
      d="M17.854 21.0457V29.9727H8.927V21.0457H17.854V12.1187H1.564C0.7 12.1187 0 12.8187 0 13.6827V37.3347C0 38.1987 0.7 38.8987 1.564 38.8987H25.217C26.081 38.8987 26.781 38.1987 26.781 37.3347V21.0457H17.854Z"
      fill="url(#paint0_linear_2317_23273)"
    />
    <path
      d="M17.854 3.19287V12.1189H26.781V21.0459H35.708V4.75687C35.708 3.89287 35.008 3.19287 34.144 3.19287H17.854Z"
      fill="#758195"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2317_23273"
        x1="25.224"
        y1="13.6757"
        x2="10.035"
        y2="28.8657"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
